import React from 'react'
import {
  Box,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles
} from '@material-ui/core'
import { formatCpf, formatDateTime } from '../../utils/Formatter'
import moment from 'moment'
import { BRAND } from '../../branding'

const useStyles = makeStyles({
  container: {
    '@media print': {
      display: 'block'
    }
  }
})

const SolicitacaoPrint = ({ item, isFrotista }) => {
  const classes = useStyles()

  const getdMotoristaFrotista = () => {
    const data = moment().format('DDMMYYmmss')
    return `${item.motorista?.codpessoa}${data}`
  }

  const id = isFrotista ? getdMotoristaFrotista() : item.id

  document.title = `Central de Cadastros - ${BRAND.displayName || BRAND.name} #${id}`

  const placas = item.veiculos ? item.veiculos.map(v => v.placa) : []
  return (
    <Box className={classes.container}>
      <Grid container spacing={3} className="no-break">
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={4}>
              <img alt={BRAND.name} src={BRAND.logo} />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h3" align="center">
                Protocolo de Análise
              </Typography>
              <Typography variant="h5" align="center">
                Identificador: {id}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Box marginTop={6} />
            <Grid item xs={12}>
              <Typography variant="h5">Informações do Motorista</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                <b>Nome:</b> {item.motorista?.nome}
              </Typography>
              <Typography>
                <b>CPF:</b> {formatCpf(item.motorista?.cpf)}
              </Typography>
              <Typography>
                <b>RG:</b> {item.motorista?.rg}
              </Typography>
              <Typography>
                <b>CNH:</b> {item.motorista?.cnhNumero}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell variant="head">
                        <b>PESQUISA</b>
                      </TableCell>
                      <TableCell variant="head">
                        <b>STATUS</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{item.motorista?.nome}</TableCell>
                      <TableCell>APROVADO</TableCell>
                    </TableRow>
                    {placas.map(placa => (
                      <TableRow key={placa}>
                        <TableCell>{placa}</TableCell>
                        <TableCell>APROVADO</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Box marginTop={6} />
            <Grid item xs={12}>
              <Typography>
                PROTOCOLO GERADO EM: {formatDateTime(new Date())} COM VALIDADE
                DE 1 EMBARQUE
              </Typography>
            </Grid>
            <Box marginTop={(4 - placas.length) * 6 + 48} />
            <Grid item xs={12}>
              <Typography variant="caption" align="center">
                PROTOCOLO GERADO AUTOMATICAMENTE PELO SISTEMA DE CENTRAL
                DE CADASTROS DA {BRAND.displayName || BRAND.name}.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default SolicitacaoPrint
